import { Popover } from "antd";

export function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="tn-footer"
      style={{
        marginTop: 32,
        padding: "24px",
        borderTop: "1px solid var(--tn-border-faint)",
        color: "rgba(255,255,255,0.55)",
        background: "var(--tn-chrome)",
      }}
    >
      <div
        className="tn-footer__content"
        style={{
          maxWidth: 1600,
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 24,
        }}
      >
        <Popover
          content={
            <span style={{ maxWidth: 280, display: "inline-block" }}>
              All textures on Texture Ninja are released into the public domain (CC0) &mdash; free
              for personal &amp; commercial use, no attribution required.
            </span>
          }
          placement="topRight"
        >
          <img
            alt="Public Domain CC0"
            style={{ height: 44, cursor: "help", opacity: 0.85 }}
            src="https://d1wumrtbuo797i.cloudfront.net/cc0.svg"
          />
        </Popover>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 4,
            fontSize: 13,
            textAlign: "right",
          }}
        >
          <span style={{ color: "rgba(255,255,255,0.7)", fontWeight: 500 }}>Texture Ninja</span>
          <span style={{ color: "rgba(255,255,255,0.45)" }}>
            Free public-domain textures for everyone &middot; &copy; {year}
          </span>
          <span style={{ color: "rgba(255,255,255,0.45)" }}>Feedback: joost3d@gmail.com</span>
        </div>
      </div>
    </footer>
  );
}
